import { Account, AdminAccount } from '@lib/types';

export interface AccountDTO {
  maskedCpf?: string | null;
  id: string;
  name: string;
  email: string;
  phone: string | null;
  profilePhotoUrl: string | null;
  sex?: Account['sex'];
  birthDate: string;
  role: Account['role'];
  verifiedAt: string | null;
  forcePasswordChange?: boolean;
  createdAt: string;
  updatedAt: string;
  isStoreOwner: boolean;
}

export interface AdminAccountDTO extends AccountDTO {
  deletedAt: string | null;
  blockedAt: string | null;
  lastLoginAt: string | null;
  lifecycleStatus: string;
}

export const createAccount = (dto: AccountDTO): Account => ({
  maskedCpf: dto.maskedCpf ?? null,
  id: dto.id,
  name: dto.name,
  email: dto.email,
  phone: dto.phone,
  profilePhotoUrl: dto.profilePhotoUrl,
  sex: dto.sex,
  birthDate: dto.birthDate,
  role: dto.role,
  verifiedAt: dto.verifiedAt,
  forcePasswordChange: dto.forcePasswordChange,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
  isStoreOwner: dto.isStoreOwner,
});

export const createAdminAccount = (dto: AdminAccountDTO): AdminAccount => ({
  ...createAccount(dto),
  deletedAt: dto.deletedAt,
  blockedAt: dto.blockedAt,
  lastLoginAt: dto.lastLoginAt,
  lifecycleStatus: dto.lifecycleStatus,
});
